// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14QZe","placeholdersHeader":"styles_placeholdersHeader__2SpH7","editorStyle":"styles_editorStyle__1VH9k","placeholdersBox":"styles_placeholdersBox__17b3i"};